import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Smartphone } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { usePrefs } from "@/lib/context";
import { pushSupported, isIos, isStandalone, currentSubscription, enablePush, disablePush } from "@/lib/push";

export function PushToggle() {
  const { t } = usePrefs();
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const supported = pushSupported();
  const iosHint = isIos() && !isStandalone();
  useEffect(() => { currentSubscription().then((s) => setOn(!!s)).catch(() => {}); }, []);
  const toggle = async (v) => {
    setBusy(true);
    try {
      if (v) { await enablePush(); toast.success(t("pushEnabled")); } else { await disablePush(); toast(t("pushDisabled")); }
      setOn(v);
    } catch (e) {
      toast.error(e.message === "denied" ? t("pushDenied") : t("pushFailed"));
    } finally { setBusy(false); }
  };
  return (
    <div className="border-b bg-slate-50 px-4 py-2.5" data-testid="push-toggle">
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-1.5 text-xs font-semibold text-slate-700"><Smartphone size={13} />{t("pushAlerts")}</span>
        {supported && !iosHint
          ? <Switch checked={on} disabled={busy} onCheckedChange={toggle} data-testid="push-toggle-switch" />
          : <span className="text-[10px] text-slate-400" data-testid="push-unsupported">—</span>}
      </div>
      {iosHint && <p className="mt-1 text-[10px] leading-snug text-slate-500" data-testid="push-ios-hint">{t("pushIosHint")}</p>}
      {!supported && !iosHint && <p className="mt-1 text-[10px] text-slate-500">{t("pushUnsupported")}</p>}
    </div>
  );
}
